import { Button } from 'react-bootstrap';
import { icons } from '../assets';
import { ModalArea } from './ModalButtonArea';

const { DownloadIcon } = icons;

export default function AssetVideoPreviewModal({
  show = false,
  onClose = () => {},
  title = 'Video preview',
  url = '',
  onDownload = () => {},
  downloadLoading = false,
}) {
  if (!show || !url) return null;

  return (
    <ModalArea
      size="xl"
      showModal={show}
      setShowModal={(nextShow) => {
        if (!nextShow) onClose();
      }}
      title={title}
      headingLeft={true}
      centered={true}
      bodyClassName="p-0"
      contentClassName="overflow-hidden"
    //   headerActions={
    //     <Button
    //       size="sm"
    //       color="light"
    //       variant='light'
    //       disabled={downloadLoading}
    //       onClick={onDownload}
    //       className="d-flex align-items-center gap-2">
    //       <DownloadIcon />
    //       <span>Download</span>
    //     </Button>
    //   }
      body={
        <div
          style={{
            background: '#000',
            borderRadius: '0 0 8px 8px',
            overflow: 'hidden',
            minHeight: '320px',
          }}>
          <video
            key={url}
            autoPlay
            controls
            loop
            playsInline
            onContextMenu={(e) => {
              e.preventDefault();
              return false;
            }}
            style={{
              width: '100%',
              minHeight: '320px',
              maxHeight: '75vh',
              display: 'block',
              background: 'linear-gradient(174deg, #000000, #444444)',
              objectFit: 'contain',
            }}>
            <source src={url} type="video/mp4" />
          </video>
        </div>
      }
    />
  );
}